module.exports = __webpack_public_path__ + "img/item17.875c2b69.png";